import {Component, EventEmitter, OnInit, Output} from '@angular/core';

@Component({
  selector: 'client-filter',
  templateUrl: './client-filter.component.html',
  styleUrls: ['./client-filter.component.scss']
})
export class ClientFilterComponent implements OnInit {

  @Output() onFilter = new EventEmitter<any>();

  filterValue: any;

  constructor() { }

  ngOnInit(): void {
  }

  filter(): void {
    this.onFilter.emit(this.filterValue);
  }

  clear(): void {
    this.filterValue = null;
    this.onFilter.emit(this.filterValue);
  }

}
